import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMapSigns, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule]
})
export class NotFoundComponent {
  faMapSigns = faMapSigns;
  faArrowLeft = faArrowLeft;
}
